<script lang="ts">
  /**
   * Un budget et ce qu'il en reste.
   *
   * Les deux nombres, pas seulement le reste : « il te reste 3 » ne permet pas
   * de vérifier qu'on n'a pas perdu un point en route.
   */
  let {
    titre = '',
    budget,
    depense,
    unite = '',
  }: {
    /** Vide quand un bandeau de cartouche porte déjà le nom du budget. */
    titre?: string
    budget: number
    depense: number
    unite?: string
  } = $props()

  const reste = $derived(budget - depense)
  const part = $derived(budget > 0 ? Math.min(100, (depense / budget) * 100) : 0)
</script>

<div class="jauge" class:juste={reste === 0} class:trop={reste < 0}>
  <div class="tete">
    {#if titre}<span class="titre">{titre}</span>{/if}
    <span class="reste data">
      {#if reste === 0}tout dépensé{:else if reste > 0}{reste} restant{reste > 1 ? 's' : ''}{:else}{-reste} de trop{/if}
    </span>
  </div>
  <div
    class="barre"
    class:depasse={reste < 0}
    role="progressbar"
    aria-valuenow={depense}
    aria-valuemin="0"
    aria-valuemax={budget}
  >
    <i style:width="{part}%"></i>
  </div>
  <div class="pied data">{depense} / {budget} {unite}</div>
</div>

<style>
  .jauge {
    display: grid;
  }
  .tete {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--pas);
  }
  .titre {
    font-family: 'Cinzel', serif;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 0.8rem;
  }
  .reste {
    font-size: 0.85rem;
    color: var(--ink-soft);
  }
  .juste .reste {
    color: var(--ok);
  }
  .trop .reste {
    color: var(--ko);
  }
  /* `barre` vient du design system ; ne restent ici que la marge et les deux
     couleurs de solde, qu'il ne connaît pas. */
  .barre {
    margin: calc(var(--pas) * 1.5) 0 var(--pas);
  }
  .barre :global(i) {
    transition: width 120ms ease-out;
  }
  .juste .barre :global(i) {
    background: var(--ok);
  }
  .pied {
    font-size: 0.75rem;
    color: var(--ink-soft);
  }
</style>
